import styled from 'styled-components/macro'

export const Container = styled.div`
  width: 100%;
  height: fit-content;
  position: relative;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding-bottom: 1.5rem;
`
export const ContainerContent = styled.div`
  display: flex;
  margin-top: 8px;
  margin-bottom: 8px;
  cursor: pointer;
  width: fit-content;
`
export const DriversImg = styled.img`
  cursor: pointer;
`
export const DriversTitle = styled.h3`
  font-family: 'L10';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 18px;
  /* identical to box height, or 100% */

  letter-spacing: 0.0714286px;
`
export const DriversContent = styled.h4`
  cursor: pointer;
  margin: 0;
  font-family: 'L10';
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
  /* identical to box height, or 154% */
`
